import { render, staticRenderFns } from "./AddAutoAssignRule.vue?vue&type=template&id=f8d5f648&"
import script from "./AddAutoAssignRule.vue?vue&type=script&lang=js&"
export * from "./AddAutoAssignRule.vue?vue&type=script&lang=js&"
import style0 from "./AddAutoAssignRule.vue?vue&type=style&index=0&id=f8d5f648&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports